import { ensureArray } from "../../common/utils/arrayUtilities";

export const getDisplayActualTimes = roster => ({
  display_actual_start: roster.actual_start ?? roster.start ?? roster.shift_start,
  display_actual_end: roster.actual_end ?? roster.end ?? roster.shift_end,
});

// roster display_actual_start and display_actual_end is added as a computed field for purposes such as rendering as part of the data set in search and event hours screns, an update will never be triggered on this field so it will not be sent to the server as an update nor will it be part of a WIP sent to server
export const prepareRosterArray = data => ensureArray(data).map(roster => ({
    ...roster,
    ...getDisplayActualTimes(roster),
}))